/*LIBRARY*/
import { connect } from "react-redux";
import { useEffect, useRef } from "react";

/*COMPONENT*/
import LEGEND_TEXT from "../map_legend/LEGEND_TEXT";
import SS_PIE_CHART from "./SS_PIE_CHART";

/*REDUX*/
import { set_value_insight } from "../../App/actions/insight_v2";
import { show_top_result_saved } from "../../App/actions/site_selections";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";
import ICON_BACK_ACTION from "../../Assets/jsx/ICON_BACK_ACTION";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SS_RESULT_SAVED = ({
  auth,
  layer,
  insight_reducer,
  show_top_result_saved,
  set_value_insight,
  set_value_layer,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const {
    top_result_limit,
    features_centroid_sample,
    provinsi,
    kota,
    kecamatan,
    kelurahan,
    legend_site_selection,
  } = insight_reducer;
  const { geo_layer_list, layer_id, feature_key_selected } = layer;
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id,
  )?.geo_layer;
  const features = geo_layer?.geojson?.features || [];

  const style_array = geo_layer?.style_array || [];
  const default_style_key = geo_layer?.default_style_key || "";
  const style_object = style_array.find(
    (item) => item.key === default_style_key,
  );

  const paint_object = style_object?.paint_object || {};

  const array = paint_object?.["fill-color"] || [];

  const prev_layer_id_ref = useRef();
  const prev_length_ref = useRef();

  useEffect(() => {
    const prev_layer_id = prev_layer_id_ref.current;
    prev_layer_id_ref.current = layer_id;

    const prev_length = prev_length_ref.current;
    prev_length_ref.current = features.length;

    if (
      (prev_layer_id !== layer_id || prev_length !== features.length) &&
      features?.length > 0 &&
      !!layer_id
    ) {
      show_top_result_saved();
    }
  }, [show_top_result_saved, layer_id, features?.length]);

  const on_change = (event) => {
    const name = event.target.name;
    let value = event.target.value;

    if (name === "top_result_limit") {
      let new_value = "";
      new_value = String(value);
      new_value = new_value.replace(/[^0-9]/g, "");
      new_value = Number(new_value);
      set_value_insight({
        key: name,
        value: new_value,
      });
    } else {
      set_value_insight({
        key: name,
        value: value,
      });
    }
  };

  const on_update_limit = () => {
    show_top_result_saved();
  };

  const on_fly = (feature) => {
    const feature_object_selected = features.find(
      (item) => String(item?.key) === String(feature?.properties?.key),
    );

    if (String(feature_key_selected) === String(feature?.properties?.key)) {
      set_value_layer({
        key: "feature_key_selected",
        value: "",
      });

      set_value_layer({
        key: "feature_object_selected",
        value: null,
      });
    } else {
      set_value_layer({
        key: "feature_key_selected",
        value: feature_object_selected.key,
      });

      set_value_layer({
        key: "feature_object_selected",
        value: feature_object_selected,
      });
    }
  };

  const on_back = () => {
    set_value_insight({
      key: "site_selection_view",
      value: "input",
    });
  };

  return (
    <main>
      <button
        className="circle_shape background_black margin_bottom"
        onClick={on_back}
      >
        <ICON_BACK_ACTION
          color="#fff"
          style={{
            width: "21px",
          }}
        />
      </button>
      <p className="text_bold margin_bottom">
        {dict?.["Site Selection Result"]?.[language]}
      </p>
      <p className="text_medium sub_color margin_bottom">Area</p>
      <section className="container background_grey_light margin_bottom_extra">
        {provinsi && (
          <>
            <p className="text_small sub_color">
              {dict?.["Province (Provinsi)"]?.[language]}
            </p>
            <p className="text_medium">{provinsi}</p>
          </>
        )}
        {kota && (
          <>
            <hr />
            <p className="text_small sub_color">
              {dict?.["Regency (Kabupaten)"]?.[language]}
            </p>
            <p className="text_medium">{kota}</p>
          </>
        )}
        {kecamatan && (
          <>
            <hr />
            <p className="text_small sub_color">
              {dict?.["Sub-district (Kecamatan)"]?.[language]}
            </p>
            <p className="text_medium">{kecamatan}</p>
          </>
        )}
        {kelurahan && (
          <>
            <hr />
            <p className="text_small sub_color">
              {dict?.["Village (Desa)"]?.[language]}
            </p>
            <p className="text_medium">{kelurahan}</p>
          </>
        )}
      </section>

      <p className="text_medium sub_color margin_bottom">
        {dict?.["Class Filter"]?.[language]}
      </p>
      <section className="two_container_equal container background_grey_light margin_bottom_extra">
        <SS_PIE_CHART />
        {features?.length > 0 && array?.length > 0 && legend_site_selection ? (
          <LEGEND_TEXT />
        ) : (
          <p className="text_medium sub_color">-</p>
        )}
      </section>

      <p className="text_medium sub_color margin_bottom">
        {dict?.["Number of Best Rankings Displayed"]?.[language]}
      </p>
      <section className="container background_grey_light two_container_equal margin_bottom_extra">
        <input
          name="top_result_limit"
          value={top_result_limit}
          type="text"
          min={1}
          onChange={(event) => on_change(event)}
        />
        <button
          className="button background_black"
          onClick={() => on_update_limit()}
        >
          {dict?.["Change Amount"]?.[language]}
        </button>
      </section>

      <p className="text_medium sub_color margin_bottom">
        {dict?.["Result details"]?.[language]}
      </p>

      <section
        style={{ overflowY: "auto", maxHeight: "300px" }}
        className="container background_grey_light"
      >
        {features_centroid_sample.length === 0 ? (
          <div className="text_medium sub_color">
            {dict?.["Click -Change Amount- first"]?.[language]}
          </div>
        ) : (
          <table className="table full_width">
            <tbody>
              <tr>
                <td style={{ width: "20px" }}></td>
                <td>{dict?.["Score numbers"]?.[language]}</td>
                <td>{dict?.["Class Score"]?.[language]}</td>
                <td style={{ width: "20px" }}></td>
              </tr>
            </tbody>
            <tbody>
              {features_centroid_sample.map((feature, idx) => {
                let class_color = "blue_container";
                if (
                  String(feature_key_selected) !==
                  String(feature?.properties?.key)
                ) {
                  class_color = "button_white";
                }
                return (
                  <tr
                    key={idx}
                    className={`cursor_pointer ${class_color}`}
                    onClick={() => on_fly(feature)}
                  >
                    <td>{feature.properties.index}</td>
                    <td>{feature.properties.FINAL_NUMBER_SCORE.toFixed(1)}</td>
                    <td>
                      {
                        dict?.[feature.properties.FINAL_STATUS_SCORE]?.[
                          language
                        ]
                      }
                    </td>
                    <td>
                      <ICON_VIEW
                        color={"#696969"}
                        strokeWidth={3}
                        style={{ width: "27px", height: "27px" }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  show_top_result_saved,
  set_value_insight,
  set_value_layer,
})(SS_RESULT_SAVED);
